// How good a connection is for a video lesson (product decision 2026-10-13), the same rule for
// the speed test before joining and for office. A two-way 720p call needs about 2.5 Mbps each
// way; below 1 Mbps the picture freezes.

export type SpeedResult = { downloadMbps: number; uploadMbps: number; latencyMs: number };

export type ConnectionVerdict = "GOOD" | "FAIR" | "WEAK";

export function connectionVerdict({
  downloadMbps,
  uploadMbps,
  latencyMs,
}: SpeedResult): ConnectionVerdict {
  if (downloadMbps >= 5 && uploadMbps >= 2.5 && latencyMs <= 150) return "GOOD";
  if (downloadMbps >= 1.5 && uploadMbps >= 1 && latencyMs <= 400) return "FAIR";
  return "WEAK";
}

export const VERDICT_LABELS: Record<ConnectionVerdict, string> = {
  GOOD: "Bağlantın ders için iyi.",
  FAIR: "Bağlantın yeterli; görüntü zaman zaman düşük kalitede olabilir.",
  WEAK: "Bağlantın zayıf: görüntü donabilir. Modeme yaklaşmayı, başka cihazlarda indirmeleri durdurmayı ya da kamerayı kapatmayı dene.",
};
